import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import Markdown from "react-remarkable";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove
} from "react-sortable-hoc";

const DragHandle = SortableHandle(() => (
  <p className="pointer-hand grey-text move-down-five">☰</p>
));

const GroupLevelLesson = SortableElement(
  ({ id, name, description, currentUser }) => (
    <div>
      <div className="row">
        <div className="col-md-1">
          {currentUser.superadmin ? (
            <DragHandle />
          ) : (
            <p className="light-grey-text move-down-five">☰</p>
          )}
        </div>
        <div className="col-md-1">
          <p className="move-down-five">{name}</p>
        </div>
        <div className="col-md-8">
          <span className="move-down-five">
            {description ? (
              <span className="grey-text word-break markdown-content">
                <Markdown source={description} />
              </span>
            ) : null}
          </span>
        </div>
        <div className="col-md-2">
          {currentUser.superadmin ? (
            <a
              className="btn btn-text pull-right"
              data-confirm="Are you sure you want to delete this lesson level?"
              data-method="delete"
              href={"/group_lesson_levels/" + id}
            >
              DELETE
            </a>
          ) : (
            <span data-tip="Only super admins have the ability to delete lesson level settings" className="pull-right">
              <a className="btn btn-text disabled">DELETE</a>
              <ReactTooltip />
            </span>
          )}

          {currentUser.superadmin ? (
            <a
              className="btn btn-text pull-right"
              href={"/group_lesson_levels/" + id + "/edit"}
            >
              EDIT
            </a>
          ) : (
            <span data-tip="Only super admins have the ability to edit lesson level settings" className="pull-right">
              <a className="btn btn-text disabled">EDIT</a>
              <ReactTooltip />
            </span>
          )}
        </div>
      </div>
      <hr />
    </div>
  )
);

const GroupLevelLessonList = SortableContainer(({ items, currentUser }) => {
  return (
    <span>
      <hr />
      {items.map((item, index) => (
        <GroupLevelLesson
          key={`item-${index}`}
          index={index}
          id={item.id}
          name={item.name}
          description={item.description}
          currentUser={currentUser}
        />
      ))}
    </span>
  );
});

class GroupLessonProgram extends React.Component {
  state = {
    groupLessonLevels: this.props.groupLessonLevels
  };

  updateGroupLessonLevel(groupLessonLevel) {
    axios
      .put("/group_lesson_levels/" + groupLessonLevel.id + ".json", {
        group_lesson_level: {
          sort_order: groupLessonLevel.sort_order
        }
      })
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        toastr.error("Error lesson level not updated");
        console.log(error);
      });
  }

  saveOrder() {
    var that = this;
    var groupLessonLevels = [];

    _.forEach(this.state.groupLessonLevels, function(groupLessonLevel, index) {
      groupLessonLevel.sort_order = index + 1;
      groupLessonLevels.push(groupLessonLevel);
      that.updateGroupLessonLevel(groupLessonLevel);
    });

    this.setState({ groupLessonLevels: groupLessonLevels });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(
      {
        groupLessonLevels: arrayMove(
          this.state.groupLessonLevels,
          oldIndex,
          newIndex
        )
      },
      () => {
        this.saveOrder();
        toastr.info("Order updated");
      }
    );
  };

  render() {
    return (
      <div>
        <div class="row">
          <div class="col-md-10">
            <span class="move-down-five">
              <span class="grey-text word-break">
                <div>
                  <span>
                    <h4><b>{this.props.groupLessonProgram.name}</b></h4>
                    <p>{this.props.groupLessonProgram.description}</p>
                    <p>Report Card Email Send Replies To: {this.props.groupLessonProgram.report_card_reply_to}</p>
                  </span>
                </div>
              </span>
            </span>
          </div>
          <div class="col-md-2">
            {this.props.currentUser.superadmin ? (
              <a
                className="btn btn-text pull-right"
                data-confirm="Are you sure you want to delete this lesson program?"
                data-method="delete"
                href={"/group_lesson_programs/" + this.props.groupLessonProgram.id}
              >
                DELETE
              </a>
            ) : (
              <span data-tip="Only super admins have the ability to lesson programs" className="pull-right">
                <a className="btn btn-text disabled">DELETE</a>
                <ReactTooltip />
              </span>
            )}
            {this.props.currentUser.superadmin ? (
              <a
                className="btn btn-text pull-right"
                href={"/group_lesson_programs/" + this.props.groupLessonProgram.id + "/edit"}
              >
                EDIT
              </a>
            ) : (
              <span data-tip="Only super admins have the ability to edit lesson program settings" className="pull-right">
                <a className="btn btn-text disabled">EDIT</a>
                <ReactTooltip />
              </span>
            )}
          </div>
        </div>
        <hr />
        <h4>
          <b></b>
        </h4>
        <div className="row">
          <div className="col-xs-7">
            <p className="grey-text">
              Lesson Levels - Setup your levels and skills for lessons. To change the order
              levels appear simply drag and drop the rows.
            </p>
          </div>
          <div className="col-xs-5">
            <div className="pull-right">
              {this.props.currentUser.superadmin ? (
                <a
                  className="btn btn-text"
                  href={"/group_lesson_levels/new?group_lesson_program_id=" + this.props.groupLessonProgram.id}
                >
                  ADD LESSON LEVEL ({this.props.groupLessonProgram.name})
                </a>
              ) : (
                <span data-tip="Only super admins have the ability to add lesson levels">
                  <a className="btn btn-text disabled">ADD LESSON LEVEL</a>
                  <ReactTooltip />
                </span>
              )}
            </div>
          </div>
        </div>
        <GroupLevelLessonList
          items={this.state.groupLessonLevels}
          currentUser={this.props.currentUser}
          onSortEnd={this.onSortEnd}
          useDragHandle={true}
        />
      </div>
    );
  }
}

GroupLessonProgram.propTypes = {
  groupLessonLevels: PropTypes.array,
  currentUser: PropTypes.object
};

export default GroupLessonProgram;
